import { render, staticRenderFns } from "./detailBack.vue?vue&type=template&id=fa2bbec0&"
import script from "./detailBack.vue?vue&type=script&lang=js&"
export * from "./detailBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports